export const CAMPAIGN_CONFIG = {
  // Google spreadsheet. Override with VITE_SPREADSHEET_ID.
  spreadsheetId: import.meta.env.VITE_SPREADSHEET_ID ?? '12KWOTxauo0p3NMcoFOIyR4dXxoVJgC5RSWgNGRsN488',
  // Only this range is read. Row 1 is the header and must not be empty, so the total is the cell below it: C2.
  range: 'C1:C2',
  // The number is fetched this often. Visitors in the same window share one cached answer, so the sheet is read once per window.
  refreshIntervalMs: 10000,
}
